import React from 'react'
import Event from './types/Event'

export default ({ event, wide }: { event: Event, wide: Boolean}) => {
	const slug = event.location ? event.location.slug : ''
	return (
		<a href={event.url} key={event.url} className={`event-card alt ${wide ? 'wide' : ''}`}>
			<div className={`event-info ${slug}`}>
				<div className="event-meta">
					{event.eventStatus && event.eventStatus === 'cancelled' && <span className='cancelled'>Cancelled</span>}
					<h3>{ event.title }</h3>
					{event.location &&
						(<p className="location">{event.location.title}</p>)
					}
				</div>
				<div className="event-date">
					<hr />
					<p>{event.startDisplayDate}{event.startDisplayTime && (` • ${event.startDisplayTime}`)}</p>
				</div>
			</div>
		</a>
	);
};